export default {
  'welcome.message': 'Ciao',
  'welcome.version': 'Versione',
  'label.user': 'Utente: ',
  'toast.insert.success': 'Azione completata',
  'toast.update.success': 'Modifica eseguita',
  'toast.update.error': 'Modifica fallita',
  'toast.upload.success': 'Upload completato',
  'toast.upload.error': 'Upload fallito',
  'toast.calendar.load': 'Caricamento eventi fallito',
  'toast.load.failed': 'Caricamento fallito',
  'toast.update.profile.success': 'Password aggiornata',
  'menu.ambienta': 'Ambienta',
  'menu.haccp': 'HACCP',
  'menu.privacy': 'Privacy',
  'menu.sicurezza': 'Sicurezza',
  'menu.impostazioni': 'Impostazioni',
  'menu.allegati': 'Allegati',
  'menu.prescrizioni': 'Prescrizioni',
  'menu.scadenze': 'Scadenze',
  'menu.calendario': 'Calendario',
  'menu.calendario-controlli': 'Calendario Controlli',
  'menu.nomine': 'Nomine',
  'menu.controlli': 'Tabella controlli',
  'menu.festivi': 'Festivi',
  'menu.chiusure': 'Chiusure',
  'menu.apertura': 'Apertura',
  'menu.tipo-rec': 'Tipo Rec',
  'menu.root-azienda': 'Azienda',
  'menu.root-impostazioni': 'Impostazioni',
  'menu.root-privacy': 'Privacy',
  'menu.root-sicurezza': 'Sicurezza',
  'menu.root-haccp': 'HACCP',
  'menu.appuntamenti': 'Appuntamenti',
  'menu.tiporec': 'Tipo Rec',
  'menu.azienda': 'Azienda',
  'menu.dati-azienda': 'Dati Azienda',
  'menu.addetti': 'Addetti',
  'menu.collaboratori-esterni': 'Aziende e Collaboratori Esterni',
  'menu.incarichi-aziendali-generici': 'Altri incarichi',
  'menu.calendario-scadenze': 'Calendario Scadenze',
  'menu.fornitori': 'Fornitori',
  'menu.attrezzature': 'Attrezzature / Mezzi',
  'menu.impianti': 'Impianti',
  'menu.agenti-chimici': 'Agenti Chimici',
  'menu.note-interne-globali': 'Note Interne Globali',
  'menu.dipendenti-globali': 'Dipendenti Globali',
  'menu.scadenze-formazioni-lavori': 'Scadenze Formazioni Lavori',
  'menu.scadenze-idoneita-sanitarie': 'Scadenze Idoneita Sanitarie',
  'menu.scadenze-verifiche-estintori': 'Scadenze Verifiche Estintori',
  'menu.scadenze-verifiche-impianti': 'Scadenze Verifiche Impianti',
  'menu.scadenze-generiche': 'Scadenze Generiche',
  'menu.giorni-festivi': 'Giorni Festivi',
  'menu.chiusure-ferie-turni': 'Chiusure Ferie Turni',
  'menu.giorni-apertura': 'Giorni Apertura',
  'menu.haccp-allegati': 'Allegati',
  'menu.sicurezza-allegati': 'Allegati',
  'menu.dpi': 'DPI',
  'menu.tipo-nomine': 'Tipo nomine',
  'menu.tipo-scadenze': 'Tipo scadenze',
  'menu.tipo-dipendenti': 'Tipo dipendenti',
  'menu.tipo-voce': 'Tipo voce',
  'menu.tipo-doc': 'Tipo docomento',
  'menu.argomenti': 'Argomenti',
  'menu.collaboratori-abituali': 'Collaboratori Abituali',
  'menu.categorie': 'Categorie',
  'menu.amministratori': 'Amministratori',
  'menu.dati-gdpr': 'Dati GDPR',
  'menu.fasi-dpia': 'Fasi DPIA',
  'menu.nbp-allegati': 'NBP Allegati',
  'login.welcome-message': 'Benvenuto in Ambienta',
  'user.login-title': 'Login',
  'user.login-user': 'Utente',
  'user.login-password': 'Password',
  'enter_valid_credentials': 'Credenziali errate',
  'user.login-button': 'Entra',
  'user.forgot.password': 'Password dimentaca',
  'ambienta': 'Ambienta',
  'logout': 'Esci',
  'choice-company': 'Cambia azienda',
  'table.action.edit-password': 'Modifica password',
  'table.action.reset-password': 'Reset password',
  'table.action.clone': 'Clona',
  'home': 'Home',
  'heading.azienda': 'Azienda',
  'heading.haccp': 'HACCP',
  'heading.sicurezza': 'Sicurezza',
  'heading.privacy': 'Privacy',
  'heading.impostazioni': 'Impostazioni',
  'heading.aziende-detail': 'Dettaglio Azienda',
  'heading.new': 'Inserisci',
  'heading.edit': 'Modifica',
  'heading.clone': 'Clona',
  'heading.day-detail': 'Dettaglio giorno ',
  'table.action.choice': 'Impersonifica',
  'table.action.modify': 'Modifica',
  'table.action.delete': 'Elimina',
  'message.delete-record': 'Cancellare ',
  'modal.profile-title': 'Modifica profilo',
  'modal.title.record.select': 'record selezionato',
  'modal.delete-title': 'Elimina dato',
  'modal.confirm-yes': 'Si',
  'modal.confirm-no': 'No',
  'modal.button.insert': 'Inserisci',
  'modal.button.update': 'Salva',
  'modal.button.close': 'Chiudi',
  'modal.button.next': 'Avanti',
  'modal.button.previous': 'Indietro',
  'modal.button.clone': 'Clona',
  'toast.reset.session.success': 'Azione completata',
  'toast.reset.session.error': 'Impossibile eseguire azione',
  'toast.delete-success': 'Azione completata',
  'column.btn': 'Azioni',
  'column.azioni.modify': 'Modifica',
  'column.azioni.delete': 'Elimina',
  'column.id': 'Id',
  'column.codcli': 'Codice',
  'column.ragsoc': 'Ragione Sociale',
  'column.indiri': 'Indirizzo',
  'column.cap': 'CAP',
  'column.locali': 'Località',
  'column.provi': 'Provincia',
  'column.codfis': 'Codice Fiscale',
  'column.pariva': 'Partita IVA',
  'column.email': 'Email',
  'column.telefo': 'Telefono',
  'column.fax': 'Fax',
  'column.titolare': 'Titolare',
  'column.resphaccp': 'Referente',
  'column.username': 'Username',
  'field.current.password': 'Password attuale',
  'field.new.password': 'Nuova Password',
  'column.dataattiv': 'Attivazione HACCP',
  'column.file_info': 'File',
  'column.hdatinizio': 'Data Inizio Gestione HACCP',
  'column.hdatsca': 'Scadenza HACCP',
  'column.pdatinizio': 'Data Inizio Privacy',
  'column.sdatinizio': 'Attivazione Sicurezza',
  'column.lavoratore-nominato': 'Lavoratore nominato',
  'column.sdatsca': 'Scadeza Sicurezza',
  'column.ndatinizio': 'Attivazione NBP',
  'column.ndatsca': 'Scadenza NBP',
  'column.idcat': 'Categoria',
  'column.email_aggiuntiva': 'Email aggiuntiva',
  'column.gdpr': 'Gestione GDPR',
  'column.pec': 'PEC',
  'column.gdpr_settori': 'Visibilità Settori',
  'column.codice_collaboratore': 'Codice Collaboratore',
  'column.gdpr_capogruppo': 'Capogruppo GDPR',
  'column.data_inizio_autocontrollo': 'Data Inizio Autocontrollo',
  'column.ambito': 'Ambito',
  'column.dataapp': 'Data App',
  'column.oraapp': 'Ora App',
  'column.tipapp': 'Tipo App',
  'column.consulente': 'Consulente',
  'column.idazi': 'Azienda',
  'column.datadoc': 'Data documento',
  'column.tipdoc': 'Tipo documento',
  'column.tipcoll': 'Tipo Collaboratore',
  'column.idcoll': 'Addetto',
  'column.nomefile': 'Nome file',
  'column.datasped': 'Data Sped',
  'column.mezzosped': 'Mezzo Sped',
  'column.percorso': 'File',
  'column.DataCreazione': 'Data creazione',
  'column.note': 'Note',
  'column.interaziendale': 'Interaziendale',
  'column.descrizione': 'Descrizione',
  'column.argomento': 'Argomento',
  'column.dexattr': 'Attrezzatura',
  'column.marcamodello': 'Marca e modello',
  'column.ambiente': 'Ambito di utilizzo',
  'column.dichconf': 'Dichiarazione comformità',
  'column.libretto': 'Libretto / Progetto',
  'column.dataacq': 'Data acquisto',
  'column.datadis': 'Data di dismissione',
  'column.targatelaio': 'Targa telaio',
  'column.datamanu': 'Manutenzione',
  'column.datarevi': 'Revisione',
  'column.omologa': 'Omologazione',
  'column.codice_abbinamento': 'Abbinamento',
  'column.nome': 'Nome',
  'column.telefono': 'Telefono',
  'column.dataini': 'Data inizio',
  'column.datafine': 'Data fine',
  'column.idcontrollo': 'Id Controllo',
  'column.data': 'Data',
  'column.ordine': 'Ordine',
  'column.flstato': 'Eseguito',
  'column.valrif': 'Val. riferimento',
  'column.diffril': 'Diff. Ril.',
  'column.azcorr': 'Azione correttiva',
  'column.controllato_da': 'Controllato da',
  'column.cognome': 'Cognome',
  'column.qualifica': 'Qualifica',
  'column.mansione': 'Mansione',
  'column.inquadramento': 'Inquadramento',
  'column.luonas': 'Luogo nascita',
  'column.datnas': 'Data nascita',
  'column.dataass': 'Data Inizio Collaborazione',
  'column.datalic': 'Data Fine Collaborazione',
  'column.tipo': 'Impianto',
  'column.dexdpi': 'Descrizione DPI',
  'column.fattore': 'Fattore',
  'column.datai': 'Data Inizio',
  'column.dataf': 'Data Fine',
  'column.prodotti': 'Prodotto / Servizio Fornito',
  'column.referenziamento': 'Referenziamento',
  'column.data_inizio': 'Data Inizio',
  'column.data_fine': 'Data Fine',
  'column.lunedi': 'Lunedì',
  'column.martedi': 'Martedì',
  'column.mercoledi': 'Mercoledì',
  'column.giovedi': 'Giovedì',
  'column.venerdi': 'Venerdì',
  'column.sabato': 'Sabato',
  'column.domenica': 'Domenica',
  'column.potenza': 'Potenza',
  'column.caratteristiche': 'Matricola',
  'column.verifica': 'Verifica',
  'column.manutenzione': 'Manutenzione',
  'column.conformita': 'Conformità',
  'column.omologazione': 'Omologazione',
  'column.testo': 'Testo',
  'column.fonte': 'Fonte',
  'column.flattiva': '',
  'column.tiponomina': 'Tipo nomina',
  'column.tipo_segnalazione': 'Tipo Segnalazione',
  'column.segnalazione': 'Note',
  'column.notificato': '',
  'column.opselin': 'Operatore',
  'column.dataril': 'Rilascio',
  'column.dexagg': 'Descrizione Agg',
  'column.username_creazione': '',
  'column.dataora_creazione': '',
  'column.username_modifica': '',
  'column.dataora_modifica': '',
  'column.gg': '',
  'column.idpar': '',
  'column.valuet': '',
  'column.valuen': '',
  'column.valued': '',
  'column.gestcli': '',
  'column.datsca': 'Scadenza',
  'column.datchiu': 'Chiusura',
  'column.chiusoda': 'Chiuso da',
  'column.utilizzo': 'Fase utilizzo',
  'column.schedasicurezza': 'Scheda sicurezza',
  'column.sostanza': 'Tipo sostanza',
  'column.qta': 'Quantitativo (KG)',
  'column.tempoespo': 'Tempo esposizione (MIN)',
  'column.idfor': 'Fornitore',
  'column.luogocons': 'Luogo conservazione',
  'column.uo': '',
  'column.denonominazione': '',
  'column.finalita': '',
  'column.software': '',
  'column.contitolare': '',
  'column.cat_interessati': '',
  'column.cat_dati_personali': '',
  'column.cat_destinatari': '',
  'column.responsabili_esterni': '',
  'column.paesi_terzi': '',
  'column.garanzie_adottate': '',
  'column.periodo_conservazione': '',
  'column.misure_adottate': '',
  'column.articolo6': '',
  'column.articolo9': '',
  'column.tipologia_trattamento': '',
  'column.fonte_dati': '',
  'column.consenso_interessati': '',
  'column.modalita_conservazione': '',
  'column.valutazione_richiesta': '',
  'column.fase_valutazione': '',
  'column.dpia': '',
  'column.timestamp_creazione': '',
  'column.timestamp_modifica': '',
  'column.tipo_record': '',
  'column.tiprec': 'Tipologia',
  'column.datains': 'Data inserimento',
  'column.tiposca': 'Tipo scadenza',
  'column.oggetto': 'Descrizione (Oggetto)',
  'column.datasca': 'Data scadenza',
  'column.preavvisogg': 'Periodicità',
  'column.datachiu': 'Data chiusura',
  'column.idnuovascad': 'idnuovascad',
  'column.notificata': 'Notificata (GG)',
  'column.esito': 'Esito',
  'column.rinnovo_automatico': 'Rinnovo automatico',
  'column.mesi_rinnovo': 'mesi_rinnovo',
  'column.datavoce': 'datavoce',
  'column.protocollo': 'Protocollo',
  'column.categoria': 'Categoria',
  'column.prescrizioni': 'Prescrizioni',
  'column.freqgg': 'Frequenza (GG)',
  'column.flsett': 'Giorni',
  'column.dex': 'Descrizione',
  'column.autocrea': 'Nominativo',
  'column.testo_notifica': 'testo_notifica',
  'column.rinnovo_automatico_tipo': 'rinnovo_automatico_tipo',
  'column.mesi_rinnovo_tipo': 'mesi_rinnovo_tipo',
  'column.pdatsca': 'Data Fine Privacy',
  'column.ricorrenza': 'Ricorrenza',
  'column.password': 'Password',
  'upload.succes.file-removed': 'File rimosso',
  'upload.error.file-removed': 'Errore durante elimnazione file',
  'upload.file-exceed': 'File non accettato. Controllare estensione / dimensioni',
  'heading.day-detail-control': 'Controlli presenti',
  'export.excel': 'Esporta in Excel',
  'export.loading': 'Export in corso...',
  'export.complete': 'Export completato',
  'toast.reset-pwd-success': 'Password resettata con successo',
  'modal.reset-pwd-title': 'Resetta pasword',
  'message.reset-pwd': 'Resettare pasword per',
  'field.current.user': 'Inserire username',
  'modal.confirm': 'Conferma',
  'modal.abort': 'Annulla'
}
